import { getStatus } from '../reducers/realtime.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRealtime from '@fc-store/reducers/realtime.reducer';

export const getRealtimeState = createFeatureSelector<fromRealtime.State>(
  fromRealtime.realtimeFeatureKey,
);
export const getRealtimeConnectionStatus = createSelector(
  getRealtimeState,
  getStatus,
);
